export type DialingCountry = {
  value: string;
  dial_code: string;
};

export const splitPhoneNumber = <T extends DialingCountry>(
  phoneNumber: string,
  countries: T[],
  defaultCountryCode = 'CR'
) => {
  const country = phoneNumber
    ? [...countries]
        .sort((a, b) => b.dial_code.length - a.dial_code.length)
        .find(({ dial_code }) => phoneNumber.startsWith(dial_code))
    : undefined;

  return {
    countryCode: country?.value || defaultCountryCode,
    localNumber: country
      ? phoneNumber.slice(country.dial_code.length)
      : phoneNumber,
  };
};

export const joinPhoneNumber = <T extends DialingCountry>(
  localNumber: string,
  countryCode: string,
  countries: T[]
) => {
  if (!localNumber) return '';
  const country = countries.find(({ value }) => value === countryCode);
  return `${country?.dial_code || ''}${localNumber}`;
};

export const validateProfileDetails = (details: {
  firstname: string;
  lastname: string;
  email: string;
}) => {
  const errors: string[] = [];
  if (!details.firstname.trim()) errors.push('First name is required.');
  if (!details.lastname.trim()) errors.push('Last name is required.');
  if (!details.email.trim()) errors.push('Email is required.');
  if (details.email && !/^\S+@\S+\.\S+$/.test(details.email)) {
    errors.push('Enter a valid email address.');
  }
  return errors;
};
